import HeroBg from "public/managedUnmanaged/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Find the best IT management model for your business",
    link: "contact-us",
  },
  title: "Protect Your Multi-Cloud & Hybrid Environments",
  desc: "Choose the right IT management approach—fully managed, self-managed, or co-managed to optimize your cloud environment and operations.",
  image: HeroBg,
};
